// Couleurs des canaux sur la carte Conversions (Figma — Signal 2026 Q2 rebranding).
// Source unique partagée par le donut (chart-donut-conversions) et le bar chart
// (conversionsAnalysis → FunnelConversionsChart) pour que les deux visualisations
// de la même carte restent toujours accordées.
export const CONVERSION_CHANNEL_COLORS: Record<string, string> = {
  Organic: '#18a055',
  Paid: '#DAA335',
};
